import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="pt-20" data-testid="payment-cancel-page">
      <section className="py-24 md:py-36">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <span className="inline-flex w-14 h-14 rounded-full border border-gold items-center justify-center text-gold">
            <XCircle size={22} strokeWidth={1.5} />
          </span>
          <h1 className="mt-8 font-display text-ink font-medium text-4xl md:text-5xl leading-[1.1]">
            Nothing was charged.
          </h1>
          <p className="mt-6 text-inkdim text-[15px] leading-relaxed">
            You stepped out of checkout, so the slot has been released. It'll still be
            there for a while if you'd like to pick up where you left off.
          </p>
          <Link
            to="/booking"
            data-testid="cancel-retry-link"
            className="inline-block mt-10 bg-deep text-canvas text-xs uppercase tracking-[0.24em] font-semibold px-9 py-4 hover:bg-gold transition-colors duration-300"
          >
            Choose a time again
          </Link>
        </div>
      </section>
    </main>
  );
}
